var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Flex } from 'reflexbox';
import { applyCyAttribute, css, mq, styled } from "../../utils";
var StyledBanner = styled.div(function (_a) {
    var _b = _a.theme, colors = _b.colors, fonts = _b.fonts, fontWeights = _b.fontWeights, fontSizes = _b.fontSizes, space = _b.space;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: ", ";\n    width: 100%;\n    font-family: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    color: ", ";\n    box-sizing: border-box;\n    display: flex;\n    justify-content: center;\n    ", ";\n  "], ["\n    background-color: ", ";\n    width: 100%;\n    font-family: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    color: ", ";\n    box-sizing: border-box;\n    display: flex;\n    justify-content: center;\n    ", ";\n  "])), colors.primary, fonts.primary, fontWeights.medium, fontSizes.small, colors.white, mq({
        padding: ["".concat(space[4], " 0"), "".concat(space[5], " 0")],
    }));
});
var StyledText = styled.div("\n  max-width: 860px;\n  padding: 0px 20px;\n");
var HintBanner = function (_a) {
    var hidden = _a.hidden, text = _a.text, rest = __rest(_a, ["hidden", "text"]);
    return hidden ? null : (React.createElement(Flex, __assign({ "data-component": "HintBanner", flexDirection: 'row' }, rest),
        React.createElement(StyledBanner, null,
            React.createElement(StyledText, __assign({}, applyCyAttribute('hint', 'text')), text))));
};
export default HintBanner;
var templateObject_1;
//# sourceMappingURL=HintBanner.js.map